<div class="modal">
    <div class="header">
        <div class="smash-logo">
            <i class="icon-smash_icologo_chip"></i>
        </div>
        <div class="title title-big" translate>UPLOADER_FORBIDDEN_TITLE</div>
    </div>
    <div class="body">
        <div class="section">
            <p>
                {{ 'UPLOADER_FORBIDDEN_TEXT1' | translate }}
            </p>
            <p>
                {{ 'UPLOADER_FORBIDDEN_TEXT2' | translate }}
            </p>
        </div>
    </div>
    <div class="footer">
        <button class="btn-new red" (click)="closeModal()">{{ 'UPLOADER_FORBIDDEN_CLOSE' | translate }}</button>
    </div>
</div>